import { GroupInfo, SingleSetting } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { InputFieldSpec } from "./JobServiceInterface";
import { InputFieldType } from "./JobState";

const inputFieldSpecs: InputFieldSpec[] =
  [
    {
      title: { da: "Indstillinger", en: "Settings" },
      valueKey: "showSettings",
      type: InputFieldType.Settings
    },
    {
      title: { da: "Afgang", en: "Departure" },
      type: InputFieldType.Title,
    },
    {
      title: { da: "Afgangslokationer", en: "Departure locations (layer)" },
      valueKey: "selectedLayerId_From",
      type: InputFieldType.SelectLayer
    },
    {
      title: { da: "Afgangs ID", en: "From Id (column)" },
      valueKey: "selectedColumnId_From_Id",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
      disAllowDefault: true
    },
    {
      title: { da: "Ankomst, 1", en: "Dest Id 1 (column)" },
      valueKey: "selectedColumnId_From_DestId_1",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
      disAllowDefault: true
    },
    {
      title: { da: "Ankomst, 2", en: "Dest Id 2 (column)" },
      valueKey: "selectedColumnId_From_DestId_2",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
    },
    {
      title: { da: "Ankomst, 3", en: "Dest Id 3 (column)" },
      valueKey: "selectedColumnId_From_DestId_3",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
    },
    {
      title: { da: "Ankomst, 4", en: "Dest Id 4 (column)" },
      valueKey: "selectedColumnId_From_DestId_4",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
    },
    {
      title: { da: "Ankomst, 5", en: "Dest Id 5 (column)" },
      valueKey: "selectedColumnId_From_DestId_5",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_From_Options",
    },
    {
      title: { da: "Ankomst", en: "Arrival" },
      type: InputFieldType.Title,
    },
    {
      title: { da: "Ankomstlokationer", en: "Arrival locations (layer)" },
      valueKey: "selectedLayerId_To",
      type: InputFieldType.SelectLayer
    },
    {
      title: { da: "Ankomst ID", en: "To Id (column)" },
      valueKey: "selectedColumnId_To_Id",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_To_Options",
      disAllowDefault: true
    },
    {
      title: { da: "Senest Ankomst", en: "Latest arrival (column)" },
      valueKey: "selectedColumnId_To_Latest",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_To_Options",
    },
    {
      title: { da: "Tidligst Ankomst", en: "Earliest arrival (column)" },
      valueKey: "selectedColumnId_To_Earliest",
      type: InputFieldType.SelectColumn,
      optionsKey: "selectedLayerId_To_Options",
    },
  ];

const settingsGroups: GroupInfo = [
  {
    key: "tidsvindue",
    da: "Tidsvindue",
    en: "Time Window"
  },
  {
    key: "routing",
    da: "Ruteplanlægning",
    en: "Routing"
  },
  {
    key: "viamapRouter",
    da: "Ruteplanlægning (Vejnettet)",
    en: "Routing (Road Network)"
  },
  {
    key: "rejseplanRouter",
    da: "Ruteplanlægning (Rejseplanen)",
    en: "Routing (Travel Planner)"
  },
  {
    key: "transportmidler",
    da: "Transportmidler (Rejseplanen)",
    en: "Modes of Transport (Travel Planner)"
  },
  {
    key: "technical",
    da: "Teknisk",
    en: "Technical"
  }
]

const settings: SingleSetting[] = [
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.intercityTog",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Intercitytog",
    en: "Intercity Train",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.lyntog",
    default: false,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Lyntog",
    en: "High Speed Train",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.regionaltog",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Regionaltog",
    en: "Regional Train",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.stog",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "S-tog",
    en: "S-train",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.letbane",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Letbane",
    en: "Light rail",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.øvrigeTog",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Øvrige tog",
    en: "Other trains",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.bus",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Bus",
    en: "Bus",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.expressbus",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Expressbus",
    en: "Express Bus",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.øvrigebusser",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Øvrige busser",
    en: "Other buses",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.teleflex",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Telebus/Flexbus/Plustur/Flextur",
    en: "Telebus/Flexbus/Plustur/Flextur",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.medtagFlex",
    default: false,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Medtag flextrafik (filter)",
    en: "Include Flextrafik (filter)",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.metro",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Metro",
    en: "Metro",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.færge",
    default: true,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Færge",
    en: "Ferry",
  },
  {
    access: Feature.JobModule,
    group: "transportmidler",
    key: "transportmidler.maxtransfers",
    default: 5,
    min: 0,
    max: 5,
    type: "Integer",
    da: "Maks antal skift",
    en: "Max transfers",
  },
  {
    access: Feature.JobModule,
    group: "rejseplanRouter",
    key: "gangcykel.maxCykelAfgang",
    default: 5000,
    min: 0,
    max: 10000,
    suffix: "m",
    type: "Integer",
    da: "Maks cykelafstand afgang",
    en: "Max bike distance departure",
  },
  {
    access: Feature.JobModule,
    group: "rejseplanRouter",
    key: "gangcykel.maxCykelAnkomst",
    default: 0,
    min: 0,
    max: 10000,
    suffix: "m",
    type: "Integer",
    da: "Maks cykelafstand ankomst",
    en: "Max bike distance destination",
  },
  {
    access: Feature.JobModule,
    group: "routing",
    key: "gangcykel.cykelhastighed",
    default: 15,
    min: 0,
    max: 50,
    type: "Integer",
    suffix: "km/t",
    da: "Cykelhastighed",
    en: "Bike speed",
  },
  {
    access: Feature.JobModule,
    group: "routing",
    key: "gangcykel.ganghastighed",
    default: 4.6,
    min: 0,
    max: 50,
    type: "Float",
    precision: 0.1,
    suffix: "km/t",
    da: "Ganghastighed",
    en: "Walk speed",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.modsatretning",
    default: false,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Modsat retning",
    en: "Reverse direction",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.date",
    type: "Date",
    default: undefined,
    da: "Dato",
    en: "Date",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.time",
    type: "TimeADay",
    default: 28800, // ="08:00",
    da: "Tidspunkt",
    en: "Time",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.timeAppliesTo",
    default: true,
    type: "Boolean",
    true: { "da": "Ankomst", "en": "Arrival" },
    false: { "da": "Afrejse", "en": "Departure" },
    da: "Tidspunkt gælder for",
    en: "Time applies to",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.maxTravelTime",
    default: 90,
    min: 0,
    max: 1000,
    type: "Integer",
    da: "Maks rejsetid (min)",
    en: "Max travel time (min)",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.maxTimeWindowStart",
    default: 45,
    min: 0,
    max: 1000,
    type: "Integer",
    da: "Maks tidsvindue afgang",
    en: "Max time window departure",
  },
  {
    access: Feature.JobModule,
    group: "tidsvindue",
    key: "tidsvindue.maxTimeWindowEnd",
    default: 45,
    min: 0,
    max: 1000,
    type: "Integer",
    da: "Maks tidsvindue ankomst",
    en: "Max time window destination",
  },
  {
    access: Feature.JobModule,
    group: "viamapRouter",
    key: "tidsvindue.transportmiddel",
    type: "Select",
    default: "auto",
    da: "Transportmiddel",
    en: "Mode of transport",
    options: [
      { value: "auto", da: "Automatisk", en: "Automatic" },
      { value: "car", da: "Bil", en: "Car" },
      { value: "bicycle", da: "Cykel", en: "Bike" },
      { value: "foot", da: "Til fods", en: "Walking" }
    ],
  },
  {
    access: Feature.JobModule,
    group: "technical",
    key: "technical.viamap.token",
    default: "eyJkcGZ4IjogImpvYnNlcnZpY2UiLCAicmVmIjogIjIiLCAicGFyIjogIiIsICJwcml2cyI6ICJyMVowcjBGMGs2QnRXcVFjT1V5a0IveTZTVXBKdjJRYmd5WGV0cTRIWTRYTy8zWXJXMCtLOXc9PSJ9.QR1rLJ5amfsGEuYhVtMV1Avag4vTdgUreBTeKuyCCFxoejZe+QrOA0uZj9ftw0RsCVWEfoWVc26rTZBmnJeonw",
    type: "String",
    da: "Viamap API token",
    en: "Viamap API token",
  },
  {
    access: Feature.JobModule,
    group: "technical",
    key: "technical.viamap.prefix",
    default: "jobservice",
    type: "String",
    da: "Viamap API prefix",
    en: "Viamap API prefix",
  },
  {
    access: Feature.JobModule,
    group: "technical",
    key: "technical.rejseplanen.token",
    default: "f624731f-5f41-4d54-b786-b34c8c2f4e3b",
    type: "String",
    da: "Rejseplanen API token",
    en: "Rejseplanen API token",
  },
]

export const JobSettingsDef = {
  inputFieldSpecs: inputFieldSpecs,
  settingsGroups: settingsGroups,
  settings: settings
}

export const JobTypeSettingsDef = {
  inputFieldSpecs: inputFieldSpecs,
  settingsGroups: settingsGroups,
  settings: settings
}